import httpClient from "@utils/httpClient";

/**
 * All employees' monthly punch-in/out day counts + release status.
 * Defaults to the previous month when year/month are omitted.
 */
export const getMonthlySummary = async (year, month) => {
  try {
    const params = [];
    if (year) params.push(`year=${year}`);
    if (month) params.push(`month=${month}`);
    const url = `/hr/salary-release/summary${params.length ? `?${params.join('&')}` : ''}`;
    const response = await httpClient.get(url);
    return {
      success: response.success,
      data: response.data || null,
      error: response.error
    };
  } catch (error) {
    console.error('getMonthlySummary error:', error);
    return { success: false, data: null, error: { message: error.message } };
  }
};

/**
 * Release salary for one employee for a month.
 */
export const releaseSalary = async (employeeId, year, month) => {
  try {
    const response = await httpClient.post('/hr/salary-release/release', { employeeId, year, month });
    return {
      success: response.success,
      data: response.data || null,
      message: response.message,
      error: response.error
    };
  } catch (error) {
    console.error('releaseSalary error:', error);
    return { success: false, data: null, error: { message: error.message || 'Failed to release salary' } };
  }
};

/**
 * Whether to show the first-working-day review banner + which period.
 */
export const getBanner = async () => {
  try {
    const response = await httpClient.get('/hr/salary-release/banner');
    return {
      success: response.success,
      data: response.data || null,
      error: response.error
    };
  } catch (error) {
    console.error('getBanner error:', error);
    return { success: false, data: null, error: { message: error.message } };
  }
};
